import React from 'react';
import { Canvas } from '@react-three/fiber';
import { Environment, Stats } from '@react-three/drei';
import Ring from './Ring';
import { RGBELoader } from 'three-stdlib';
import { useLoader } from '@react-three/fiber';

export default function ThreeCanvas({ currentSection, isSalePage }) {
  const envMap = useLoader(
    RGBELoader,
    '/hdr/christmas_photo_studio_06_1k.hdr',
  );

  return (
    <Canvas
      shadows={false}
      camera={{ position: [0, 1, 4], fov: 40 }}
      dpr={[1, 1.5]}
      style={{
        position: 'fixed',
        top: isSalePage ? '60vh' : 0,
        left: 0,
        width: '100%',
        height: isSalePage ? '40vh' : '100vh',
        zIndex: 0,
      }}
    >
      <ambientLight intensity={1} />
      <directionalLight position={[1, 1, 3]} intensity={1} />
      <directionalLight position={[-1, 1, 3]} intensity={1} color="#ffe9b1" />

      {/* Optional sparkle spot‑light */}
      <spotLight position={[3, 2, 2]} angle={0.2} penumbra={1} intensity={2} />

      {/* HDRI environment for reflections */}
      <Environment files="/hdr/christmas_photo_studio_06_1k.hdr" background={false} />

      <Ring currentSection={currentSection} envMap={envMap} isSalePage={isSalePage} />
      {/* <Stats /> */}
    </Canvas>
  );
}